import React from 'react';
import { createRoot } from 'react-dom/client';
import App from '../App';
import { initDecalCache } from '../utils/decalCache';

initDecalCache();

export function initReactApp() {
  // Purge any leaked text nodes outside root that might have spilled from malformed meta tags
  if (typeof document !== 'undefined' && document.body) {
    Array.from(document.body.childNodes).forEach((node) => {
      if (node.nodeType === Node.TEXT_NODE && node.textContent?.trim()) {
        node.remove();
      }
    });
  }

  let rootEl = document.getElementById('root');
  if (!rootEl) {
    rootEl = document.createElement('div');
    rootEl.id = 'root';
    document.body.prepend(rootEl);
  }
  const root = createRoot(rootEl);
  root.render(<App />);
}

if (typeof window !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReactApp);
  } else {
    initReactApp();
  }
}
